<template>
  <div id="map" class="map">
    <div class="map-tool" @click.stop>
      <a class="back-center" href="javascript:" @click="backCenter"></a>
      <a class="zoom-plus" href="javascript:" @click="handleZoom(true)"></a>
      <a class="zoom-minus" href="javascript:" @click="handleZoom(false)"></a>
    </div>
  </div>
</template>
<script>
import shBorder from "@/assets/json/border.json";
import gcoord from "gcoord";

export default {
  props: {
    source: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "normal",
    },
  },
  data() {
    return {
      map: null,
      center: [31.242746, 121.455917],
      featureLayer: null,
      geoJSONLayer: null,
      isMobile: document.documentElement.clientWidth <= 840,
      mapZoom: 11,
    };
  },
  watch: {
    source: {
      deep: true,
      handler() {
        this.addFeatures();
      },
    },
  },
  mounted() {
    this.initMap();
  },
  methods: {
    transLatLon(latlon) {
      return gcoord.transform(latlon, gcoord.Baidu, gcoord.AMap);
    },
    initMap() {
      this.map = this.$L.map("map", {
        center: this.center, // 地图中心
        zoom: 11, //缩放比列
        zoomControl: false, //禁用 + - 按钮
        doubleClickZoom: false, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
        maxZoom: 16, // 设置最大缩放级别 临时使用 chenss 20230615
        minZoom: 1 // 设置最小缩放级别 chenss 20230615
        
      });
      this.$L
        .tileLayer(
          "https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}"
        )
        .addTo(this.map);
      this.featureLayer = this.$L.layerGroup().addTo(this.map);
      this.map.on("zoomend", () => {
        this.mapZoom = this.map.getZoom();
        if (this.type === "normal") {
          if (this.mapZoom > 12 && this.source.resultSource.length === 0) {
            this.$parent.queryMapData();
          }
          if (this.mapZoom < 13 && this.source.source.length === 0) {
            this.$parent.queryMapData();
          }
        }
      });
      this.geoJSONLayer = this.$L
        .geoJSON(shBorder, {
          style: {
            fillOpacity: 0,
            color: "#EB5757",
            opacity: 0.6,
            weight: 3,
          },
        })
        .addTo(this.map);
      //打点
      this.addFeatures();
    },
    backCenter() {
      this.map.setView(this.center, 11);
    },
    handleZoom(flag) {
      const zoom = this.map.getZoom();
      const res = flag ? zoom + 1 : zoom - 1;
      this.map.setZoom(res);
    },
    getPopUpContent(record) {
      let { description } = record;
      if (!description) {
        description = "";
      }
      if (record.cover) {
        if (description.length > 28 && this.isMobile) {
          description = description.substr(0, 28) + "...";
        }
      } else {
        if (description.length > 50 && this.isMobile) {
          description = description.substr(0, 45) + "...";
        }
      }
      return `<div class="point-popup-detail">
                <div style="display: ${
                  record.cover ? "flex" : "none"
                }" class="pic" ><img src="${record.cover +(record.cover.indexOf('img.library.sh.cn') != -1?'!500x300':'')}" /></div>
                <div class="content-box">
                    <div class="name" title="${record.titleChs}" >${
        record.titleChs
      }</div>
                    <div class="desc ${record.cover ? "has-pic" : ""}">${
        description || ""
      }</div>
                    <div class="addr">${record.address}</div>
                    <div class="btns"><a   href="${
                      record.website
                    }" style="display: ${
        record.website && record.website.indexOf('red.library.sh.cn') != -1 ? "flex" : "none"
      }" target="_blank" class="home">查看全文<i></i></a><a  href="${record.id!= 844 ? "#/detail/"+record.id : "#"}"  class="detail">了解详情<i></i></a></div>
                </div>
              </div>`;
    },
    addFeatures() {
      this.featureLayer.clearLayers();
      const zoom = this.map.getZoom();
      if (this.type === "detail") {
        const { resultSource } = this.source;
        resultSource.forEach((d) => {
          if (!(d.lat && d.lon)) {
            return;
          }
          d.points = d.entityList;
          const isMul = d.objCount > 1;
          let name = "";
          if (isMul) {
            const arr = d.typeList.map((p) => {
              return p.typeName;
            });
            const arr2 = [...new Set(arr)];
            if (arr2.length > 2) {
              name = arr2[0] + "、" + arr2[1] + "等";
            } else {
              name = arr2.join("、");
            }
          } else {
            name = d.points[0].titleChs;
          }
          const icon = this.$L.divIcon({
            className: `custom-point`,
            html: `<div class="count ${d.typeList[0].typeKey} ${
              isMul ? "no-icon" : ""
            } ">${
              isMul ? d.objCount : ""
            }</div><div class="name" title="${name}">${name}</div>`,
          });

          const marker = this.$L
            .marker(this.transLatLon([d.lat, d.lon]), { icon })
            .addTo(this.featureLayer);
          if (d.objCount > 1) {
            marker.on("click", () => {
              const res = {
                latLon: [d.lat, d.lon],
                name: d.orgName || d.countyName,
                type: d.typeList.map((t) => {
                  return t.id;
                }),
              };
              this.$store.commit("control/SET_dotPos", res);
            });
          } else {
            marker.bindPopup(this.getPopUpContent(d.points[0]));
          }
        });
      }
      if (zoom > 13 && this.type === "normal") {
        const { resultSource } = this.source;
        resultSource.forEach((d) => {
          if (!(d.lat && d.lon)) {
            return;
          }
          d.points = d.entityList;
          const isMul = d.objCount > 1;
          let name = "";
          if (isMul) {
            const arr = d.typeList.map((p) => {
              return p.typeName;
            });
            const arr2 = [...new Set(arr)];
            if (arr2.length > 2) {
              name = arr2[0] + "、" + arr2[1] + "等";
            } else {
              name = arr2.join("、");
            }
          } else {
            name = d.points[0].titleChs;
          }
          const icon = this.$L.divIcon({
            className: `custom-point`,
            html: `<div class="count ${d.typeList[0].typeKey} ${
              isMul ? "no-icon" : ""
            } ">${
              isMul ? d.objCount : ""
            }</div><div class="name" title="${name}">${name}</div>`,
          });

          const marker = this.$L
            .marker(this.transLatLon([d.lat, d.lon]), { icon })
            .addTo(this.featureLayer);
          if (d.objCount > 1) {
            marker.on("click", () => {
              const res = {
                latLon: [d.lat, d.lon],
                name: d.orgName || d.countyName,
                type: d.typeList.map((t) => {
                  return t.id;
                }),
              };
              this.$store.commit("control/SET_dotPos", res);
              this.$store.commit("control/SET_keyword", "");
              this.$router.push("/result");
            });
          } else {
            marker.bindPopup(this.getPopUpContent(d.points[0]));
          }
        });
      }
      if (zoom <= 13 && this.type === "normal") {
        const { source } = this.source;
        source.forEach((i) => {
          if (!(i.lat && i.lon)) {
            return;
          }
          let scale = 1;
          if (i.objCount <= 5) {
            scale = 1;
          } else if (i.objCount > 5 && i.objCount <= 24) {
            scale = 2;
          } else if (i.objCount > 24) {
            scale = 3;
          }
          const icon = this.$L.divIcon({
            className: `custom-point scale-${scale}`,
            html: `<div class="count">${i.objCount}</div><div class="name">${i.county}</div>`,
          });
          const marker = this.$L
            .marker(this.transLatLon([i.lat, i.lon]), { icon })
            .addTo(this.featureLayer);
          marker.on("click", () => {
            this.$parent.countryIds = [i.id];
            switch (i.id) {
              case 11: //如果是浦东新区 特殊处理，定位到档案较多的上海市档案馆坐标 chenss 20230413
                this.map.setView(this.transLatLon([31.206603, 121.562887]), 14);
                break;
              case 17: //如果是崇明区 特殊处理，定位到 大新烈士公墓坐标 chenss 20230413
                this.map.setView(this.transLatLon([31.599071, 121.596878]), 14);
                break;
              default://默认定位到区经纬度坐标
                this.map.setView(this.transLatLon([i.lat, i.lon]), 14);
            }
          });
        });
      }
    },
  },
};
</script>
